import { epochToDateStr } from 'helpers/timeHelpers';
import moment from 'moment';

export const treatmentTypeTitles = {
	SKIN: 'Skin treatment plan',
	LASH: 'Eyelash treatment plan',
	HAIR: 'Hair treatment plan',
}

export const conditionToReadableBusinessLine = (condition) => {
	const mapping = {
		lash: 'eyelashes',
		hair: 'male pattern baldness',
		fili: 'fine lines/wrinkles',
		rose: 'rosacea',
		acne: 'acne or rosacea',
		tret: 'fine lines/wrinkles',
		hype: 'hyperpigmentation', // 'hyperpigmentation/dark spots' is too long
	};
	return mapping[condition.toLowerCase()]
};

export function canChange(cart, {
	id, disabled,
}) {
	return !cart.products[id] && !disabled
}

// if we consider the MSRP to be our lowest quantity price times the size
// difference proportionally.
export function getMsrp(options, currentOption) {
	var smQuantOpt = options[options.length - 1]
	return smQuantOpt.price_cents * currentOption.quantity/smQuantOpt.quantity
}

export function getDuration(options, currentOption, product) {
	if (!product.duration || product.duration === '') { return }
	var smQuantOpt = options[options.length - 1];
	return `${(currentOption.quantity/smQuantOpt.quantity) * product.duration} day supply`
	//#TODO update this to month supply if we re-enable multiple purchase options
}

export function dollarFormat(cents) {
	if (isNaN(cents)) {
		return false;
	}
	return `$${Math.round(cents/100)}`
}

export function getDescription(product, purchase_option) {
	if (product.subscription) {
		return 'Manage purchases through Patient Account'
	} else if (product.compounded) {
		if (product.dispense_quantity) {
			// For now, all compounded meds are 36 grams, but support displaying a potentially different quantity here
			// Assume all product.duration == "90" && purchase_option.quantity == 1
			return `${product.dispense_quantity} grams / 3 month supply`
		}
		return '21 grams / 3 month supply'
	} else {
		// Hiding pill quantity / duration which can be confusing and un-standardized
		// since this is only shown when there are no purchasable options
		if (product.dispense_quantity && product.dispense_units &&
        purchase_option && purchase_option.quantity) {
			let desc = `${purchase_option.quantity} ${String(product.dispense_units).toLowerCase()}`;
			if (String(product.dispense_units).slice(-1) !== 's') {
				// format tablet->tablets, capsule->capsules, gram->grams, etc.
				desc += 's';
			}

			if (product.duration == '30' &&
          // total quantity purchased must be divisible by dispensed quantity (for a 1-month aka 30 day supply)
          purchase_option.quantity >= product.dispense_quantity &&
          purchase_option.quantity % product.dispense_quantity === 0) {
				let month_duration = purchase_option.quantity / product.dispense_quantity;
				desc += ` / ${month_duration} month supply`;
			} else if (product.duration == '30' && purchase_option.durationStr === '45 day supply') {
				desc += ' / 45 day supply'
			}

			return desc;
		}
		return ''
	}
}

export function getShipmentNote({
	pending_request = false, shipments = [],
}) {
	if (pending_request) {
		return 'PREPARING SHIPMENT'
	} else if (shipments.length > 0) {
		return `SHIPPED ON ${epochToDateStr(shipments[0].shipped_date)}`
	}
	return '';
}

function nth(d) {
	const date = parseInt(d);
	if (date > 3 && date < 21) {
		return `${date}th`;
	}
	switch (date % 10) {
	case 1: return `${date}st`;
	case 2: return `${date}nd`;
	case 3: return `${date}rd`;
	default: return `${date}th`;
	}
}

export function getTodaysDate() {
	const today = new Date();
	const day = nth(today.getDate())
	const month_names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	const month = month_names[today.getMonth()]
	return `${month} ${day}`;
}

export function getThreeMonthsAheadDate() {
	return moment().add(3,
		'months').format('ll');
}

export function get83DaysAheadDate() {
	return moment().add(83,
		'days').format('ll');
}

export function getAROrderChangeInitialDate() {
	return moment().add(81,
		'days').format('ll');
}
